import React from 'react';
import './Spinner.scss';

interface SpinnerProps {
  error?: boolean;
}

const Spinner: React.FC<SpinnerProps> = ({ error }) => {
  if (error) {
    return <div className="spinner-error">Сервис недоступен</div>;
  }
  return (
    <div className="spinner">
      <div className="spinner-circle" />
      <div>Загрузка...</div>
    </div>
  );
};

export default Spinner;
